import InboomaBaseView from "../InboomaBaseView";
import PricetariffsSidebarTpl from "../../templates/pricetariffs/PricetariffsSidebarTpl.html";

export default InboomaBaseView.extend({
  template: PricetariffsSidebarTpl,
  el: "#inb-c-sidebar",
});
